import React from "react";

const Blogs = () => {
  return (
    <>
      <div>
        <h1>Authentication</h1> <br /> 1.User identity is confirmed <br /> 2.
        User and user server is verified <br /> 3. Login details, usernames,
        passwords, OTPs required
        <br /> 4. Data is available via Token IDs <br /> 5. User can partially
        change the authentication details as per the requirement
      </div>
      <div>
        <h1>Authorization</h1> 1. Here, the user is given permission to access
        the system / resources after validation
        <br /> 2. Here it is validated if the user is allowed to access via some
        defined rules <br />
        3. Checks the security level and privilege of the user, thus determining
        what the user can or cannot have access to <br />
        4. Data provided via Access token <br />
        5. User cannot modify the Authorization permissions as it is given to a
        user by the owner/manager of the system, and only has the authority to
        change it.
      </div>
      <div>
        <h1> Why are you using firebase?</h1>
        <br />
        1. Incredibly Built-In Analytics <br />
        2. App Development Made Easy <br />
        3. Growth and User Engagement <br />
      </div>
      <div>
        <h1>What other options do you have to implement authentication?</h1>
        1. Biometrics <br /> 2. Token Authentication <br /> 3. Transaction
        Authentication <br /> 4. Multi-Factor Authentication (MFA) <br /> 5.
        Out-of-Band Authentication (OOB)
      </div>
      <div>
        <h1>
          What other services does firebase provide other than authentication
        </h1>
        <br />
        1. Cloud Firestore. <br /> 2. Cloud Functions. <br /> 3. Authentication.{" "}
        <br />
        4. Hosting. <br /> 5. Cloud Storage. <br />
        6. Google Analytics. <br /> 7. Predictions. <br />
        8. Cloud Messaging.
      </div>
    </>
  );
};

export default Blogs;
